import { NotificationService } from '@/services/masters/user/notificationService';
import { globalApiService } from '../globalApiSlice';
import type { MyNotification } from '@/types/user/notification-types';
import type { StoreBaseResponse } from '@/types/types';
import type { RequestOptions } from '@/services/apiService';
import { createCustomError, createCustomResponse } from '@/helpers/utils';

const service = new NotificationService();

const notificationsApi = globalApiService.injectEndpoints({
  endpoints: (build) => ({
    getMyNotifications: build.mutation<
      StoreBaseResponse<MyNotification[]>,
      RequestOptions['params']
    >({
      queryFn: async (body) => {
        try {
          const response = await service.getMyNotifications(body);
          return createCustomResponse(response);
        } catch (error) {
          return createCustomError(error);
        }
      },
    }),
  }),
});

export const { useGetMyNotificationsMutation } = notificationsApi;
